<my-content placeholder="navigation">




    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>
    <div class="col-sm-12" style="margin-top: 8px;">
        <div class=" col-sm-12 lefticonD paddingless" style="border:1px solid #ccc; ">
            <label>Manage Notification Configuration </label>
        </div>
        <div class="col-sm-12"><br></div>
        <!-- <form #SearchNotification="ngForm" [formGroup]="FormSearchNotification" (ngSubmit)="onSearchNotification(SearchNotification.value);"> -->
        <form #SearchNotification="ngForm" [formGroup]="FormSearchNotification">
            <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">

                <div class="col-sm-12">

                    <div class="col-sm-1 text-left height-34">Module</div>
                    <div class="col-sm-2"><select class="form-control " formControlName="Module" (change)="onModuleSelect($event.target.value)"><option value="0">[Not Selected] </option> <option *ngFor="let mDtl of Module " value="{{mDtl.MainID}}">{{mDtl.MainDescr}}</option></select></div>
                    <div class="col-sm-1 text-left height-34">Feature</div>
                    <div class="col-sm-2"><select class="form-control " formControlName="Feature" (change)="onFeatureSelect($event.target.value)"><option value="0">[Not Selected] </option> <option *ngFor="let mDtl of Features " value="{{mDtl.SubID}}">{{mDtl.SubDescr}}</option></select></div>
                    <div class="col-sm-1 text-left height-34" [hidden]="HideContent">Enable &nbsp;&nbsp;<input type="checkbox" class="text-left height-34" formControlName="recEnable" (change)="onChange($event);" [checked]="isSelected" /> </div>
                    <div class="col-sm-2 text-left height-34" [hidden]="HideContent">Is Mail To Client &nbsp;&nbsp;<input type="checkbox" class="text-left height-34" formControlName="IsMailToClient" (change)="onChangeClientMail($event);" [checked]="isSelectedClient" /> </div>
                    <div class="col-sm-1" [hidden]="HideContent"><input class="btn btn-primary btn-sm-12 " type="submit" (click)="SaveData()" value="Submit"></div>
                    <!-- <div class="col-sm-1">&nbsp;</div> -->
                    <div class="col-sm-1" [hidden]="HideContent">
                        <div class="col-sm-12 btn btn-light"><a Title="Print" (click)="print()"><i class="material-icons">
                        print
                        </i><span id="MaterialText">Print</span></a></div>
                    </div>
                    <div class="col-sm-1 text-left height-34 btn btn-light" [hidden]="HideContent"><a routerLink="{{MailRoute}}"><i class="material-icons"> email</i><span id="MaterialText">Mail Template</span></a> </div>

                </div>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12" style="margin-top: 8px;" [hidden]="HideContent">
                    <form [formGroup]="Form">
                        <table width="100%" class="LMtable">
                            <tr>
                                <th>S.No.</th>
                                <th>Employee Name</th>
                                <th>Selected Manager For E-mail</th>
                                <!-- <th>Other E-mail</th> -->
                                <th>Selected Manager For SMS</th>
                                <!-- <th>Other Mobile </th> -->
                                <!-- <th><input type="checkbox" id="CheckData" (change)="selectAll(this.pageNumber,$event);"></th> -->
                            </tr>

                            <!-- ============== Show Message / Loading ============== -->
                            <tr *ngIf="this.MsgType == 1">
                                <td colspan="80">
                                    <div class="d-flex align-items-center">
                                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                                        <div class="spinner-border" role="status"></div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="this.MsgType == 2">
                                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                                    <span>{{DisplayMessage}}</span>
                                </td>
                            </tr>
                            <tr *ngIf="this.MsgType == 3">
                                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                                    <input type="hidden" value={{this.ReportID}} [formControlName]="'Report'">
                                    <!-- <input type="hidden" value={{this.}} [formControlName]="'recEnable'"> -->
                                </td>
                            </tr>
                            <!-- ==================================================== -->

                            <tr *ngFor="let ND of NotificationData; let i=index">
                                <td align="center">{{i+1}}

                                    <input type="hidden" value={{ND.recEnable}} [formControlName]="'recEnable|'+ND.ID">
                                    <input type="hidden" value={{ND.IsClient}} [formControlName]="'IsClient|'+ND.ID">
                                    <input type="hidden" value={{ND.ID}} [formControlName]="'ID|'+ND.ID">
                                </td>
                                <td> {{ND.UserName}} </td>
                                <td>
                                    <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'EmailManager|'+ND.ID" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="ND.SelectedEmail">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            {{item.UserName}} &nbsp; &nbsp;{{item.Email}}
                                        </ng-template>
                                    </ng-select>
                                    <input type="hidden" class="form-control" [value]="ND.Email" [formControlName]="'Email|'+ND.ID" />
                                </td>
                                <td>
                                    <ng-select [items]="UserMasterDetail" [clearable]="false" [multiple]="true" [formControlName]="'SmsManager|'+ND.ID" bindLabel="UserName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID" [(ngModel)]="ND.SelectedSms">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            {{item.UserName}} &nbsp; &nbsp;{{item.Mobile}}
                                        </ng-template>
                                    </ng-select>
                                    <input type="hidden" class="form-control" value={{ND.Mobile}} [formControlName]="'Sms|'+ND.ID" />
                                </td>

                                <!-- <td> <input type="checkbox" id="{{mDtl.ID}}" [checked]="isSelected[(pageNumber - 1) * 2 + i +1]"> {{(pageNumber - 1) * 2 + i +1 }}</td> -->


                            </tr>
                        </table>
                    </form>
                    <br>

                </div>

            </div>
        </form>
    </div>

    <!-- <div class="col-sm-12" style="margin-top: 8px;">
      <div class=" col-sm-12 lefticonD paddingless" style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
          <label>{{TypeHeader}} </label>
      </div>

      <br>

  </div> -->


    <div><br>&nbsp;</div>

    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-4 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>

</my-content>
<my-content placeholder="main">

</my-content>
